import type { AlgoliaContentfulPage } from '~/lib/AlgoliaService/models/AlgoliaContentfulPage';

export function isAlgoliaContentfulPage(
  result: unknown
): result is AlgoliaContentfulPage {
  // XXX: every search result should contain a "type" attribute for proper
  //  identification. Checking the locale might not be sufficient...
  return typeof result === 'object' && result != null && 'locale' in result;
}
